(() => {
  const elementName = 'cm-search-shape-tabs';
  if (window.customElements.get(elementName)) return;

  class CMSearchShapeTabs extends HTMLElement {
    connectedCallback() {
      this._listeners?.abort();
      this._listeners = new AbortController();
      const owned = selector => Array.from(this.querySelectorAll(selector)).filter(element => element.closest(elementName) === this);
      const panels = owned('[role="tabpanel"]');
      this._pairs = owned('[role="tab"]').map(tab => ({
        tab,
        panel: panels.find(panel => panel.id === tab.getAttribute('aria-controls'))
      })).filter(pair => pair.panel);
      if (!this._pairs.length) return;

      for (const { tab } of this._pairs) {
        tab.addEventListener('click', () => this._activate(tab), { signal: this._listeners.signal });
        tab.addEventListener('keydown', event => this._onKeyDown(event, tab), { signal: this._listeners.signal });
      }
      const selected = this._pairs.find(({ tab }) => tab.getAttribute('aria-selected') === 'true');
      this._activate((selected || this._pairs[0]).tab);
    }

    disconnectedCallback() {
      this._listeners?.abort();
    }

    _activate(activeTab, focus = false) {
      for (const { tab, panel } of this._pairs) {
        const selected = tab === activeTab;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        panel.hidden = !selected;
      }
      if (focus) activeTab.focus();
    }

    _onKeyDown(event, tab) {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      const index = this._pairs.findIndex(pair => pair.tab === tab);
      let next;
      switch (event.key) {
        case 'ArrowRight': next = (index + 1) % this._pairs.length; break;
        case 'ArrowLeft': next = (index - 1 + this._pairs.length) % this._pairs.length; break;
        case 'Home': next = 0; break;
        case 'End': next = this._pairs.length - 1; break;
        default: return;
      }
      event.preventDefault();
      this._activate(this._pairs[next].tab, true);
    }
  }

  window.customElements.define(elementName, CMSearchShapeTabs);
})();
